Vue.component('ack-shop-product-grid', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-shop-product-grid',
  mounted() {

    
  },
  props:{
    prop1: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    isBundleView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...Vuex.mapGetters('shop', ['productList', 'selectedProductList']),
    
  },
  data() {
    return {
      var1: null
    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    ...Vuex.mapActions('shop', ['addSelectedItem', 'removeSelectedItem', 'buyNowMany', 'addToCart']),
    
    onProductSelected(product){
      this.addSelectedItem(product)
    },
    onProductUnselected(product){
      this.removeSelectedItem(product)
    },

    onBuyBundle(){
      this.buyNowMany({itemInfoArray: this.selectedProductList})
      .then((url)=>{
        openCheckoutUrl(url)
      })
    },
    
    onAddToCartBundleClick(){
      this.addToCart(this.selectedProductList)
    },

  },
  beforeDestroy() {
    
  },
  watch: {
    prop1: {
      handler() {
        
        
      },
      deep: false
    }
  }
})